import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import { db } from "../../firebase.config";
import CustomButton from "../../Components/CustomButton";
import EventCard from "../../Components/EventCard";
import Iconify from "../../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../../context/VariableContext";
import CustomTextField from "../../Components/CustomTextField";

const Monitoring = ({ affiliation }) => {
    const { openLogin, setOpenLogin } = Variables();
    const [loading, setLoading] = React.useState(false);
    const [events, setEvents] = React.useState([]);
    const [countTmp, setCount] = React.useState(0);
    const createEventList = (doc) => {
        setEvents((events) => [...events, doc]); // ajouter a la fin
    };
    React.useEffect(() => {
        (async () => {
            try {
                //
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        })();
    }, []);

    // champs
    //connexion section


    return (
        <Box>
            {
                affiliation &&
                <Grid container sx={{ color: 'white' }} spacing={2}>
                    <Grid item xs={6} sm={4}>
                        <Box padding={3} sx={{ width: '100%', heigth: '100%', border: '2px solid #292929', borderRadius: '7px' }}>
                            <Typography variant="subtitle1">Revenues Generés</Typography>
                            <Typography variant="h6">{affiliation?.data().revenueGenerated ? affiliation?.data().revenueGenerated : '-'}</Typography>
                        </Box>
                    </Grid>
                    {
                        affiliation?.data().commission &&
                        <Grid item xs={6} sm={4}>
                            <Box padding={3} sx={{ width: '100%', heigth: '100%', border: '2px solid #292929', borderRadius: '7px' }}>
                                <Stack direction='row' spacing={1} alignItems='center'>
                                    <Typography variant="subtitle1">Commission</Typography>
                                    <Typography variant="caption"> ({affiliation?.data().commission.value} {affiliation?.data().commission?.type === 1 ? '%' : 'CFA'})</Typography>
                                </Stack>
                                <Typography variant="h6">{(affiliation?.data().revenueGenerated*affiliation?.data().commission.value)/100}</Typography>
                            </Box>
                        </Grid>
                    }

                    <Grid item xs={6} sm={4}>
                        <Box padding={3} sx={{ width: '100%', heigth: '100%', border: '2px solid #292929', borderRadius: '7px' }}>
                            <Typography variant="subtitle1">Nombre de billet vendu</Typography>
                            <Typography variant="h6">{affiliation?.data().sell ? affiliation?.data().sell : '-' }</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Box padding={3} sx={{ width: '100%', height: '100%', border: '2px solid #292929', borderRadius: '7px' }}>
                            <Typography variant="subtitle1">Nombre de Clicks</Typography>
                            <Stack direction='row' spacing={1} alignItems='center'>
                                <Typography variant="h6">{affiliation?.data().clicks}</Typography>
                                <Typography variant="caption"> ({affiliation?.data().sell / affiliation?.data().clicks}% de rendement)</Typography>
                            </Stack>

                        </Box>
                    </Grid>
                </Grid>
            }

        </Box>
    );
};

export default Monitoring;
